(() => {
  const config = document.querySelector('[data-gcb-collection-return]');
  if (!config) return;
  const key = 'gcb-collection-return-v1';
  const collectionPath = /\/collections\/[^/]+\/?$/;
  const productPath = /\/products\/[^/]+\/?$/;
  const clean = (value) => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || !collectionPath.test(url.pathname)) return null;
    for (const name of [...url.searchParams.keys()]) {
      if (!name.startsWith('filter.') && !['sort_by', 'page', 'preview_theme_id'].includes(name)) url.searchParams.delete(name);
    }
    url.hash = '';
    return url;
  };
  if (config.dataset.pageType === 'collection') {
    const remember = (event) => {
      const anchor = event.target.closest?.('a[href]');
      if (!anchor) return;
      const target = new URL(anchor.href, location.origin);
      if (target.origin !== location.origin || !productPath.test(target.pathname)) return;
      const source = clean(location.href);
      if (!source) return;
      const record = {
        url: source.href,
        title: config.dataset.collectionTitle,
        product: target.pathname,
        time: Date.now()
      };
      try { sessionStorage.setItem(key, JSON.stringify(record)); } catch (_) {}
    };
    for (const event of ['pointerdown', 'click', 'auxclick', 'contextmenu']) {
      document.addEventListener(event, remember, true);
    }
    return;
  }
  const links = document.querySelectorAll('[data-gcb-return-link]');
  if (!links.length || !document.referrer) return;
  let source;
  try { source = clean(document.referrer); } catch (_) { return; }
  if (!source) return;
  let title = '';
  try {
    const record = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (record && record.product === location.pathname && Date.now() - record.time < 1800000) {
      const saved = clean(record.url);
      if (saved && saved.pathname === source.pathname) {
        source = saved;
        title = typeof record.title === 'string' ? record.title : '';
      }
    }
  } catch (_) {}
  const size = source.searchParams.get('filter.p.m.custom.coin_size');
  links.forEach((link) => {
    link.href = source.pathname + source.search;
    link.textContent = (title || config.dataset.returnLabel) + (size ? ' · ' + size : '');
    link.title = link.textContent;
  });
})();